
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import CategoriesPage from "@/pages/categories/CategoriesPage";
import CategoryCreatePage from "@/pages/categories/CategoryCreatePage";
import CategoryEditPage from "@/pages/categories/CategoryEditPage";

export function CategoryRoutes() {
  return (
    <>
      <Route 
        path="/categories" 
        element={
          <ProtectedRoute>
            <CategoriesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/categories/new" 
        element={
          <ProtectedRoute>
            <CategoryCreatePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/categories/:id/edit" 
        element={
          <ProtectedRoute>
            <CategoryEditPage />
          </ProtectedRoute>
        } 
      />
    </>
  );
}
